import {connect} from 'react-redux';

import {QuicksurveyStore} from 'client/common/types';

import {selectPreset} from 'client/common/store/reducers/question-bank';
import {sendParams} from 'client/common/store/actions/metrika';

import {getInitialPreset, getPreset} from 'client/common/store/selectors/question-bank';
import {getUserIsAgency} from 'client/common/store/selectors/user';

import {DispatchProps, OwnProps, StateProps} from './types';

import Component from './survey-creator';

const mapStateToProps = (state: QuicksurveyStore): StateProps => {
    return {
        initialPreset: getInitialPreset(state),
        preset: getPreset(state),
        userIsAgency: getUserIsAgency(state)
    };
};

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, {
    selectPreset,
    sendParams
})(Component);
